import React from 'react';
import { useTranslation } from 'react-i18next';

import useClasses from '../../../hooks/useClasses';
import Button from '../../Button';
import WebformMapper from '../Mapper';
import type { IMap, Submission } from '../types';
import './style.scss';

interface WebformSubmissionProps {
  id: string,
  onEdit: () => void,
  onClose: () => void,
  entities: IMap,
  info: IMap,
  exerciseSubmission: Submission,
}

const WebformSubmission: React.FC<WebformSubmissionProps> = ({
  id,
  onEdit,
  onClose,
  ...props
}) => {
  const { t } = useTranslation();
  const { buildClass } = useClasses('WebformSubmission');

  return (
    <div className={buildClass()}>
      <div className={buildClass('questions')}>
        <p>{t('webform.submission.intro')}</p>
        <WebformMapper {...props} />
      </div>

      <div className={buildClass('actions')}>
        <Button
          inverted
          onClick={onEdit}
        >
          {t('webform.submission.actions.edit')}
        </Button>
        <Button onClick={onClose}>
          {t('webform.submission.actions.close')}
        </Button>
      </div>
    </div>
  );
};

export default WebformSubmission;
